import styled from 'styled-components/macro';

import {useState} from "react";
import {
    Button,
    FormControl,
    FormHelperText,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea
} from "@chakra-ui/react";
import {useFeedback} from "../../store/feedback";
import {useModMessage} from "../../api/moderation";

const Item = styled.div``;
const Save = styled.div``;

const ModMessage = styled(({className, post, comment, onClose}) => {
    const {feedbackCh} = useFeedback();
    const author = post ? post.author : comment.author;
    const community = post ? post.community : comment.community;
    const [subject, setSubject] = useState('');
    const [content, setContent] = useState('');
    const modMessage = useModMessage(feedbackCh);
    const handleModMessage = async () => {
        try {
            await modMessage(author, community, subject, content);
        } catch {}
        onClose();
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Message u/{author}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Stack spacing={'5'}>

                        <FormControl>
                            <FormLabel>Title</FormLabel>
                            <Input placeholder="" value={subject}
                                   onChange={(e) => setSubject(e.currentTarget.value)}/>
                            <FormHelperText>This message will be sent from c/{community}.</FormHelperText>
                        </FormControl>

                        <FormControl>
                            <FormLabel>Content</FormLabel>
                            <Textarea type="content" value={content} rows={5}
                                      onChange={(e) => setContent(e.currentTarget.value)}
                            />
                        </FormControl>

                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" onClick={handleModMessage}>
                        Send
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
`;

export default ModMessage;
